import useMediaQuery from '@mui/material/useMediaQuery';

import theme from 'shared/themes/default';
import NativeSelect, { type NativeSelectProps } from './NativeSelect';
import CustomSelect, { type CustomSelectProps } from './CustomSelect';

type SelectProps = NativeSelectProps | CustomSelectProps;

const Select = (props: SelectProps) => {
  const isPhone = useMediaQuery(theme.breakpoints.mobile);

  return isPhone ? <NativeSelect {...props} /> : <CustomSelect {...props} />;
};

export default Select;
export type { SelectProps };
